module.exports = {"610103001":"南院门街道","610103002":"柏树林街道","610103003":"长乐坊街道","610103004":"东关南街街道","610103005":"太乙路街道","610103006":"文艺路街道","610103007":"长安路街道","610103008":"张家村街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610103.json
// module id = 2570
// module chunks = 0